import styled from 'styled-components';

const ICON_SIZE = 8;

export const StyledIconWrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radii.lg}px;
  box-shadow: ${({ theme }) => theme.shadows[100]};
  height: ${({ theme }) => theme.spacing(ICON_SIZE)}px;
  width: ${({ theme }) => theme.spacing(ICON_SIZE)}px;
  background-color: ${({ theme }) => theme.colors.surface[0]};
`;
